export default __webpack_public_path__ + "static/media/165.e6fcf046.jpg";